import React from "react";
import { DocumentIdPictureUpload } from "./components/DocumentIdPictureUpload";
import { DocumentIdPictureCameraMode } from "./components/DocumentIdPictureCameraMode";
import { CAPTURE_MODES } from "../../config";

export const DocumentIdPicture = ({
  documentSide,
  captureMode,
  onSubmitForm,
}) => {
  if (captureMode === CAPTURE_MODES.UPLOAD) {
    return <DocumentIdPictureUpload onSubmitForm={onSubmitForm} />;
  }
  return (
    <DocumentIdPictureCameraMode
      documentSide={documentSide}
      onSubmitForm={onSubmitForm}
    />
  );
};
